import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = [
        'typeSelect',
        'recurringAvailabilityFields',
        'absenceFields',
        'startTime',
        'endTime',
        'recurringAvailabilityStartTime',
        'recurringAvailabilityEndTime',
    ]

    connect() {
        this.toggleType()
    }

    toggleType() {
        if (!this.hasTypeSelectTarget) return

        const type = this.typeSelectTarget.value
        const isAbsence = type === 'absence'
        const modalTitle = document.querySelector('.new-modal__title')

        if (modalTitle) {
            modalTitle.textContent = isAbsence ? 'Abwesenheit hinzufügen' : 'Zeitslot hinzufügen'
        }

        this.recurringAvailabilityFieldsTarget.classList.toggle('d-none', isAbsence)
        this.absenceFieldsTarget.classList.toggle('d-none', !isAbsence)

        this.toggleFields(this.recurringAvailabilityFieldsTarget, isAbsence)
        this.toggleFields(this.absenceFieldsTarget, !isAbsence)
    }

    toggleFields(container, disabled) {
        container.querySelectorAll('input, select').forEach((el) => (el.disabled = disabled))
    }

    updateEndTime() {
        const startTimeStr = this.startTimeTarget.value
        const endTimeStr = this.endTimeTarget.value

        if (startTimeStr) {
            const startDate = new Date(startTimeStr)

            // Minimum is +1 minute for server validation, Default is +1 hour for convenience
            const minEndDate = new Date(startDate.getTime() + 60 * 1000)
            const defaultEndDate = new Date(startDate.getTime() + 60 * 60 * 1000)

            const minEndStr = this.formatDateTimeLocal(minEndDate)
            const defaultEndStr = this.formatDateTimeLocal(defaultEndDate)

            if (!endTimeStr || endTimeStr <= startTimeStr) {
                this.endTimeTarget.value = defaultEndStr
            }

            this.endTimeTarget.min = minEndStr
        }
    }

    updateRecurringAvailabilityEndTime() {
        const startTime = this.recurringAvailabilityStartTimeTarget.value
        const endTime = this.recurringAvailabilityEndTimeTarget.value

        if (startTime) {
            this.recurringAvailabilityEndTimeTarget.min = startTime

            if (!endTime || endTime <= startTime) {
                // Default to +1 hour using a Date object for cleaner math
                const [hours, minutes] = startTime.split(':').map(Number)
                const date = new Date()
                date.setHours(hours + 1, minutes)
                
                const newEndTime = `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
                this.recurringAvailabilityEndTimeTarget.value = newEndTime
            }
        }
    }

    formatDateTimeLocal(date) {
        // Offset-aware ISO string for datetime-local input
        const offset = date.getTimezoneOffset() * 60000
        return new Date(date.getTime() - offset).toISOString().slice(0, 16)
    }
}
